export default class Story {
  constructor(
    id,
    name
  ) {
    this.id = id
    this.name = name
  }
}
